export const shadows = [
  'none',
  '0 2px 11px 1px rgba(0, 0, 0, 0.15)',
  '0 0.5px 1px 0 rgba(0, 0, 0, 0.1)',
];
